

















































import Vue from "vue";
import AppHeading from "../components/AppHeading.vue";
import { ILS_CONTACT_EMAIL } from "../constants";

const REPORT_2017_FILE_PATH = `/EB00163627.pdf`;
const REPORT_2018_FILE_PATH = `/EB00246286.pdf`;
const REPORT_2019_FILE_PATH = `/2019_beszamolo.pdf`;

export default Vue.extend({
  name: "about",
  data() {
    return {
      email: ILS_CONTACT_EMAIL,
      REPORT_2017_FILE_PATH: REPORT_2017_FILE_PATH,
      REPORT_2018_FILE_PATH: REPORT_2018_FILE_PATH,
      REPORT_2019_FILE_PATH: REPORT_2019_FILE_PATH
    };
  },
  components: { AppHeading }
});
